import React, { useEffect, useRef, useState } from "react";

const API_BASE_URL = (
  process.env.REACT_APP_API_BASE_URL || "http://localhost:5000"
).replace(/\/+$/, "");

function BackToTop() {
  const [isBackToTopVisible, setIsBackToTopVisible] = useState(false);

  const [scrollProgress, setScrollProgress] = useState(0);

  const [isWhatsappMenuOpen, setIsWhatsappMenuOpen] = useState(false);

  const [selectedWhatsappLanguage, setSelectedWhatsappLanguage] =
    useState(null);

  const whatsappAreaRef = useRef(null);
  const [whatsappNumbers, setWhatsappNumbers] = useState({
    contact_phone: "",
    contact_phone_alt: "",
  });

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;

      const scrollHeight =
        document.documentElement.scrollHeight - window.innerHeight;

      const progress =
        scrollHeight > 0
          ? Math.min(100, Math.max(0, (scrollTop / scrollHeight) * 100))
          : 0;

      setScrollProgress(progress);
      setIsBackToTopVisible(scrollTop > 50);
    };

    window.addEventListener("scroll", handleScroll, {
      passive: true,
    });

    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        whatsappAreaRef.current &&
        !whatsappAreaRef.current.contains(event.target)
      ) {
        setIsWhatsappMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();

    const fetchWhatsappNumbers = async () => {
      try {
        const response = await fetch(
          `${API_BASE_URL}/api/contact/whatsapp-numbers`,
          {
            method: "GET",
            headers: {
              Accept: "application/json",
            },
            signal: controller.signal,
          },
        );

        const responseData = await response.json().catch(() => ({}));

        if (!response.ok || responseData.success === false) {
          throw new Error(
            responseData.message || "WhatsApp numaraları alınamadı.",
          );
        }

        setWhatsappNumbers({
          contact_phone: responseData.contact_phone || "",
          contact_phone_alt: responseData.contact_phone_alt || "",
        });
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("WHATSAPP_NUMBER_FETCH_ERROR:", error);
        }
      }
    };

    fetchWhatsappNumbers();

    return () => {
      controller.abort();
    };
  }, []);
  const normalizeWhatsappNumber = (value) => {
    let digits = String(value || "").replace(/\D/g, "");

    // 0090 ile girilmişse
    if (digits.startsWith("00")) {
      digits = digits.slice(2);
    }

    // 05XX... şeklindeyse
    if (digits.startsWith("0")) {
      digits = `90${digits.slice(1)}`;
    }

    // 5XX... şeklinde 10 hane ise
    if (digits.length === 10 && digits.startsWith("5")) {
      digits = `90${digits}`;
    }

    return digits;
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const toggleWhatsappMenu = () => {
    setIsWhatsappMenuOpen((current) => !current);
  };

  const selectWhatsappLanguage = (language) => {
    setSelectedWhatsappLanguage(language);

    const rawPhoneNumber =
      language === "TR"
        ? whatsappNumbers.contact_phone
        : whatsappNumbers.contact_phone_alt;

    const whatsappNumber = normalizeWhatsappNumber(rawPhoneNumber, language);

    if (!whatsappNumber) {
      window.alert(
        language === "TR"
          ? "Türkçe WhatsApp numarası tanımlanmamış."
          : "English WhatsApp number is not defined.",
      );

      return;
    }

    const defaultMessage =
      language === "TR"
        ? "Merhaba, bilgi almak istiyorum."
        : "Hello, I would like to get information.";

    const whatsappUrl =
      `https://wa.me/${whatsappNumber}` +
      `?text=${encodeURIComponent(defaultMessage)}`;

    setIsWhatsappMenuOpen(false);

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  const openWhatsapp = () => {
    const whatsappNumber = normalizeWhatsappNumber(
      whatsappNumbers.contact_phone,
    );

    if (!whatsappNumber) {
      return;
    }
    const defaultMessage = "Merhaba, bilgi almak istiyorum.";

    const whatsappUrl =
      `https://wa.me/${whatsappNumber}` +
      `?text=${encodeURIComponent(defaultMessage)}`;

    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <style>
        {`
          .demirsan-floating-actions {
            position: fixed;
            right: 24px;
            bottom: 24px;

            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 12px;

            z-index: 99999;
          }

          /* WHATSAPP ALANI */
          .demirsan-whatsapp-area {
            position: relative;

            display: flex;
            align-items: center;
            justify-content: center;
          }

          .demirsan-whatsapp-button {
            position: relative;

            display: flex;
            align-items: center;
            justify-content: center;

            width: 52px;
            height: 52px;
            min-width: 52px;
            min-height: 52px;

            margin: 0;
            padding: 0;

            color: #ffffff;
            background: #25d366;

            border: none;
            border-radius: 50%;

            box-shadow:
              0 7px 20px rgba(0, 0, 0, 0.2),
              0 0 0 4px rgba(37, 211, 102, 0.12);

            cursor: pointer;

            transition:
              transform 0.2s ease,
              box-shadow 0.2s ease,
              background-color 0.2s ease;
          }

          .demirsan-whatsapp-button:hover,
          .demirsan-whatsapp-button.active {
            background: #20bd5a;
            transform: translateY(-2px);

            box-shadow:
              0 9px 24px rgba(0, 0, 0, 0.23),
              0 0 0 5px rgba(37, 211, 102, 0.15);
          }

          .demirsan-whatsapp-button svg {
            display: block;
            width: 29px;
            height: 29px;
          }

          .demirsan-whatsapp-button svg path {
            fill: #ffffff !important;
          }

          /* WHATSAPP DİL SEÇİM KUTUSU */
          .demirsan-whatsapp-language-menu {
            position: absolute;
            right: 64px;
            top: 50%;

            width: 205px;

            padding: 10px;

            background: #ffffff;

            border: 1px solid rgba(11, 23, 53, 0.1);
            border-radius: 10px;

            box-shadow:
              0 12px 35px rgba(0, 0, 0, 0.18);

            opacity: 0;
            visibility: hidden;
            pointer-events: none;

            transform:
              translateY(-50%)
              translateX(10px);

            transition:
              opacity 0.2s ease,
              visibility 0.2s ease,
              transform 0.2s ease;

            z-index: 100000;
          }

          .demirsan-whatsapp-language-menu.open {
            opacity: 1;
            visibility: visible;
            pointer-events: auto;

            transform:
              translateY(-50%)
              translateX(0);
          }

          /* WhatsApp kutusu ile buton arasındaki küçük ok */
          .demirsan-whatsapp-language-menu::after {
            content: "";

            position: absolute;
            right: -7px;
            top: 50%;

            width: 14px;
            height: 14px;

            background: #ffffff;

            border-top: 1px solid rgba(11, 23, 53, 0.1);
            border-right: 1px solid rgba(11, 23, 53, 0.1);

            transform:
              translateY(-50%)
              rotate(45deg);
          }

          .demirsan-whatsapp-menu-title {
            display: block;

            margin-bottom: 8px;
            padding: 0 4px;

            color: #0b1735;

            font-size: 13px;
            font-weight: 700;
            line-height: 1.4;
          }

          .demirsan-whatsapp-language-list {
            display: flex;
            flex-direction: column;
            gap: 6px;

            margin: 0;
            padding: 0;

            list-style: none;
          }

          .demirsan-whatsapp-language-list li {
            width: 100%;
            margin: 0;
            padding: 0;
          }

          .demirsan-whatsapp-language-option {
            display: grid;
            grid-template-columns: 31px minmax(0, 1fr) 18px;
            align-items: center;
            gap: 9px;

            width: 100%;
            min-height: 48px;

            margin: 0;
            padding: 7px 9px;

            color: #17213a;
            background: #f6f7f9;

            border: 1px solid transparent;
            border-radius: 7px;

            font-family: inherit;
            text-align: left;

            cursor: pointer;

            transition:
              color 0.2s ease,
              background-color 0.2s ease,
              border-color 0.2s ease;
          }
.demirsan-whatsapp-language-option:hover {
  color: #17213a !important;
  background: #eaf8ef !important;
  border-color: #25a95b !important;
}

.demirsan-whatsapp-language-option.selected {
  color: #ffffff !important;
  background: #25a95b !important;
  border-color: #1e8d4a !important;
}

.demirsan-whatsapp-language-option:hover
.demirsan-whatsapp-language-name,
.demirsan-whatsapp-language-option:hover
.demirsan-whatsapp-language-description {
  color: #17213a !important;
}

.demirsan-whatsapp-language-option.selected
.demirsan-whatsapp-language-name,
.demirsan-whatsapp-language-option.selected
.demirsan-whatsapp-language-description {
  color: #ffffff !important;
}
  
          .demirsan-whatsapp-flag {
            display: flex;
            align-items: center;
            justify-content: center;

            width: 31px;
            height: 25px;

            background: #ffffff;
            border-radius: 4px;

            font-size: 19px;
            line-height: 1;
          }

          .demirsan-whatsapp-language-text {
            display: flex;
            flex-direction: column;
            min-width: 0;
          }
            .demirsan-whatsapp-flag {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;

  width: 31px !important;
  height: 25px !important;

  color: initial !important;
  background: #ffffff !important;

  border: 1px solid rgba(11, 23, 53, 0.08) !important;
  border-radius: 4px !important;

  font-size: 19px !important;
  line-height: 1 !important;

  opacity: 1 !important;
  visibility: visible !important;
}

          .demirsan-whatsapp-language-name {
            font-size: 13px;
            font-weight: 700;
            line-height: 1.3;
          }

          .demirsan-whatsapp-language-description {
            margin-top: 1px;

            font-size: 10px;
            font-weight: 500;
            line-height: 1.3;

            opacity: 0.72;
          }

          .demirsan-whatsapp-check {
            display: flex;
            align-items: center;
            justify-content: center;

            width: 18px;
            height: 18px;

            color: #ffffff;
            background: rgba(255, 255, 255, 0.22);

            border-radius: 50%;

            font-size: 10px;
            font-weight: 700;

            opacity: 0;
          }

          .demirsan-whatsapp-language-option.selected
          .demirsan-whatsapp-check {
            opacity: 1;
          }

          /* BACK TO TOP DIŞ HALKASI */
          .demirsan-back-to-top-ring {
            position: relative;

            display: flex;
            align-items: center;
            justify-content: center;

            width: 56px;
            height: 56px;
            min-width: 56px;
            min-height: 56px;

            padding: 3px;

            border-radius: 50%;

            opacity: 0;
            visibility: hidden;
            pointer-events: none;

            transform: translateY(12px);

            transition:
              opacity 0.25s ease,
              visibility 0.25s ease,
              transform 0.25s ease;

            box-shadow:
              0 7px 20px rgba(0, 0, 0, 0.18);
          }

          .demirsan-back-to-top-ring.visible {
            opacity: 1;
            visibility: visible;
            pointer-events: auto;

            transform: translateY(0);
          }

          /* HALKANIN İÇİNDEKİ KIRMIZI BUTON */
          .demirsan-back-to-top {
            display: flex;
            align-items: center;
            justify-content: center;

            width: 50px;
            height: 50px;
            min-width: 50px;
            min-height: 50px;

            margin: 0;
            padding: 0;

            color: #ffffff;
            background: #e60000;

            border: 3px solid #ffffff;
            border-radius: 50%;

            cursor: pointer;

            box-shadow:
              inset 0 0 0 1px rgba(255, 255, 255, 0.1);

            transition:
              background-color 0.2s ease,
              transform 0.2s ease;
          }

          .demirsan-back-to-top:hover {
            background: #bd0000;
            transform: scale(1.03);
          }

          /* YUKARI OK */
          .demirsan-back-to-top-arrow {
            position: relative;

            display: block;

            width: 20px;
            height: 23px;

            pointer-events: none;
          }

          .demirsan-back-to-top-arrow::before {
            content: "";

            position: absolute;
            top: 5px;
            left: 50%;

            width: 3px;
            height: 17px;

            background: #ffffff;
            border-radius: 3px;

            transform: translateX(-50%);
          }

          .demirsan-back-to-top-arrow::after {
            content: "";

            position: absolute;
            top: 3px;
            left: 50%;

            width: 11px;
            height: 11px;

            border-top: 3px solid #ffffff;
            border-left: 3px solid #ffffff;

            transform:
              translateX(-50%)
              rotate(45deg);
          }

          @media (max-width: 575.98px) {
            .demirsan-floating-actions {
              right: 16px;
              bottom: 16px;
              gap: 10px;
            }

            .demirsan-whatsapp-button {
              width: 48px;
              height: 48px;
              min-width: 48px;
              min-height: 48px;
            }

            .demirsan-whatsapp-button svg {
              width: 27px;
              height: 27px;
            }

            .demirsan-back-to-top-ring {
              width: 52px;
              height: 52px;
              min-width: 52px;
              min-height: 52px;
            }

            .demirsan-back-to-top {
              width: 46px;
              height: 46px;
              min-width: 46px;
              min-height: 46px;
            }

            .demirsan-back-to-top-arrow {
              transform: scale(0.9);
            }

            .demirsan-whatsapp-language-menu {
              position: fixed;
              right: 16px;
              top: auto;
              bottom: 132px;

              width: min(230px, calc(100vw - 32px));

              transform: translateY(8px);
            }

            .demirsan-whatsapp-language-menu.open {
              transform: translateY(0);
            }

            .demirsan-whatsapp-language-menu::after {
              display: none;
            }
          }
        `}
      </style>

      <div className="demirsan-floating-actions">
        <div className="demirsan-whatsapp-area">
          <button
            type="button"
            className="demirsan-whatsapp-button"
            aria-label="WhatsApp ile iletişime geç"
            title="WhatsApp"
            onClick={openWhatsapp}
          >
            <svg viewBox="0 0 32 32" aria-hidden="true">
              <path d="M16.04 3C8.86 3 3 8.72 3 15.77c0 2.46.72 4.85 2.08 6.9L3.7 27.72l5.21-1.35a13.13 13.13 0 0 0 7.12 2.06h.01c7.18 0 13.03-5.72 13.03-12.77C29.07 8.72 23.22 3 16.04 3Zm0 23.27h-.01a10.95 10.95 0 0 1-5.59-1.52l-.4-.24-3.1.8.83-3.02-.26-.41a10.51 10.51 0 0 1-1.68-5.7c0-5.84 4.58-10.59 10.21-10.59 5.63 0 10.21 4.75 10.21 10.59 0 5.84-4.58 10.59-10.21 10.59Zm5.6-7.93c-.31-.15-1.82-.88-2.1-.98-.28-.1-.49-.15-.69.15-.21.3-.8.98-.98 1.18-.18.2-.36.23-.67.08-.31-.15-1.3-.47-2.48-1.49-.92-.8-1.54-1.79-1.72-2.09-.18-.3-.02-.46.14-.61.14-.14.31-.36.46-.54.15-.18.21-.31.31-.51.1-.2.05-.38-.03-.54-.08-.15-.69-1.63-.95-2.23-.25-.6-.5-.51-.69-.52h-.59c-.21 0-.54.08-.82.38-.28.3-1.08 1.03-1.08 2.52s1.11 2.93 1.26 3.13c.15.2 2.18 3.26 5.28 4.57.74.31 1.31.5 1.76.64.74.23 1.41.2 1.94.12.59-.09 1.82-.73 2.08-1.43.26-.71.26-1.32.18-1.44-.08-.13-.28-.2-.59-.35Z" />
            </svg>
          </button>
        </div>

        {/* Scroll halkası */}
        <div
          className={`demirsan-back-to-top-ring ${
            isBackToTopVisible ? "visible" : ""
          }`}
          style={{
            background: `conic-gradient(
              #e60000 0%,
              #e60000 ${scrollProgress}%,
              rgba(230, 0, 0, 0.18) ${scrollProgress}%,
              rgba(230, 0, 0, 0.18) 100%
            )`,
          }}
        >
          <button
            type="button"
            className="demirsan-back-to-top"
            onClick={scrollToTop}
            aria-label="Sayfanın başına dön"
            title="Yukarı çık"
          >
            <span className="demirsan-back-to-top-arrow" aria-hidden="true" />
          </button>
        </div>
      </div>
    </>
  );
}

export default BackToTop;
